<template>
	<span 
    v-if="numTeams > 0"
    class="subprogram-nba-summary-start-season-button"
  >
		<el-button
      :disabled="!enableButton"
			type="primary"
			@click="handleOnClick"
		>
			<app-i18n
				code="entities.subprogram.nba.startSeason.button"
			/>
		</el-button>
    
    <!-- Alerts -->
    <custom-alert
      v-if="currentAlert"
      :visible.sync="visibleAlert"
      :type="currentAlert.type"
      :title="currentAlert.title"
      :description="currentAlert.description"
      :confirmText="currentAlert.confirmText"
      :onConfirmFn="currentAlert.onConfirmFn"
      :onCloseFn="currentAlert.onCloseFn"
      :visibleOnConfirm="true"
      :lockClose="lockClosePerType(currentAlert.type)"
    />
	</span>
</template>

<script>
import { i18n } from '@shared/i18n';
import { mapGetters, mapActions } from 'vuex';
import { get } from 'lodash';

export default {
	name: 'app-subprogram-nba-summary-start-season-button',

	props: {
		propertyId: {
			type: String,
			required: true,
		},
		subpropertyId: {
			type: String,
			required: true,
		},
		programId: {
			type: String,
			required: true,
		},
		subprogramId: {
			type: String,
			required: true,
    },
	},

	data() {
		return {
      visibleAlert: false,
      currentAlert: null
		};
	},

  computed: {
    ...mapGetters({
      numTeams: 'subprogram/nba/summary/numTeams',
      numTeamsUnmatched: 'subprogram/nba/summary/numTeamsUnmatched',
      numMinTeamMatched: 'subprogram/nba/summary/numMinTeamMatched',
      numTeamsMatched: 'subprogram/nba/summary/numTeamsMatched',
      loadingStartRegularSeason: 'subprogram/nba/summary/loadingStartRegularSeason',
      rounds: 'subprogram/nba/summary/rounds',
      subprogram: 'subprogram/nba/subprogram',
    }),
    enableButton() {
      return this.numTeamsMatched >= this.numMinTeamMatched;
    },
    alert() {
      return {
        first: {
          key: 'first',
          type: 'info',
          title: i18n('entities.subprogram.nba.startSeason.alerts.first.title'),
          description: i18n('entities.subprogram.nba.startSeason.alerts.first.description'),
          confirmText: i18n('common.continue'),
          onConfirmFn: () => {},
          onCloseFn: () => this.onClose(),
        },
        second: {
          key: 'second',
          type: 'warning',
          title: i18n('entities.subprogram.nba.startSeason.alerts.second.title'),
          description: i18n('entities.subprogram.nba.startSeason.alerts.second.description', this.numTeamsUnmatched),
          confirmText: i18n('common.continue'),
          onConfirmFn: () =>  {},
          onCloseFn: () =>  this.onClose(),
        },
        third: {
          key: 'third',
          type: 'loading',
          title: i18n('entities.subprogram.nba.startSeason.alerts.third.title'),
          confirmText: i18n('common.continue'),
          onConfirmFn: () => {},
          onCloseFn: () => this.onClose(),
        },
        four: {
          key: 'four',
          type: 'success',
          title: i18n('entities.subprogram.nba.startSeason.alerts.four.title'),
          description: i18n('entities.subprogram.nba.startSeason.alerts.four.description'),
          confirmText: i18n('common.continue'),
          onConfirmFn: () => {},
          onCloseFn: () => this.onClose(),
        },
        five: {
          key: 'five',
          type: 'warning',
          title: i18n('entities.subprogram.nba.startSeason.alerts.five.title'),
          description: i18n('entities.subprogram.nba.startSeason.alerts.five.description'),
          confirmText: i18n('entities.subprogram.nba.startSeason.rounds.add'),
          onConfirmFn: () =>  {},
          onCloseFn: () =>  this.onClose(),
        },
      }
    },
    isRegularSeasonHasRounds() {
      return get(this, 'subprogram.regularSeasonHasRounds', false); 
    },
  },

	methods: {
    ...mapActions({
      doStartRegularSeason: 'subprogram/nba/summary/doStartRegularSeason',
      doInitParams: 'subprogram/nba/doInitParams',
    }),

		handleOnClick() {
      this.visibleAlert = true;
      this.currentAlert = Object.assign({}, this.alert.first);
    },

		i18n(code) {
			return i18n(code);
    },
    
    onClose() {
      this.currentAlert.key = '';
    },

    lockClosePerType(type) {
      return !(type === 'loading') && !(type === 'success');
    },
  },
  
  watch: {
    async 'currentAlert.key'(key) {

      switch (key) {
        case 'first':
          this.currentAlert.onConfirmFn = async ()  => {
            if (this.isRegularSeasonHasRounds && this.rounds.length < 2) {
              this.currentAlert = get(this, 'alert.five', null);
            } else if ( this.numTeamsUnmatched === 0 ) {
              this.currentAlert = get(this, 'alert.third', null);
            } else {
              this.currentAlert = get(this, 'alert.second', null);
            }
          }
          break;
        case 'second':
            this.currentAlert.onConfirmFn = async ()  => {
              this.currentAlert = get(this, 'alert.third', null);
            }
          break;
        case 'third':
            var success = await this.doStartRegularSeason({
                propertyId: this.propertyId,
                subpropertyId: this.subpropertyId,
                programId: this.programId,
                subprogramId: this.subprogramId,
              });

              if (success) {
                this.currentAlert = get(this, 'alert.four', null);
              } else {
                this.visibleAlert = false;
              }

            // setTimeout(() => {
            //   var success = true;
            //   if (success) {
            //     this.currentAlert = get(this, 'alert.four', null);
            //   } else {
            //     this.visibleAlert = false;
            //   }
            // }, 5000);
          break;
        case 'four':
          this.currentAlert.onConfirmFn = async ()  => {
            await this.doInitParams({
              propertyId: this.propertyId,
              subpropertyId: this.subpropertyId,
              programId: this.programId,
              subprogramId: this.subprogramId,
            });
            this.visibleAlert = false;
          }
          break;
        case 'five':
          this.currentAlert.onConfirmFn = async ()  => {
            this.$router.push({
              name: 'SubprogramRegularSeasonRoundsNew',
              params: {
                programId: this.programId,
                subprogramId: this.subprogramId,
              },
            });
            this.visibleAlert = false;
          }
          break;
        default:
          break;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
</style>